import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Rugby = () => {
  return (
    <SportsLayoutComp name={'Rugby'}/>
  )
}

export default Rugby